import { render, staticRenderFns } from "./ChartCardSkeleton.vue?vue&type=template&id=d508a36e&scoped=true"
import script from "./ChartCardSkeleton.vue?vue&type=script&lang=js"
export * from "./ChartCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ChartCardSkeleton.vue?vue&type=style&index=0&id=d508a36e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d508a36e",
  null
  
)

export default component.exports